import { createFileRoute } from '@tanstack/react-router'
import { WebRelays } from '../../../features/serviceManagement/webRelays/WebRelays.tsx'

export const Route = createFileRoute('/_app/smp/webRelays')({
	component: WebRelays,
})
